// extracted by mini-css-extract-plugin
module.exports = {"page":"ApplyOnline_page__1_7hC","content":"ApplyOnline_content__3sRvs"};